<template>
  <div class="VerifiedClientList">
    <component
      v-if="!!verifiedClientListFSearchGridMetaData"
      :ref="verifiedClientListFSearchGridMetaData.myRefName"
      :is="verifiedClientListFSearchGridMetaData.componentName"
      :value="selectModel(verifiedClientListSearchGridInput, undefined)"
      v-bind="verifiedClientListFSearchGridMetaData.props"
    ></component>
  </div>
</template>

<script lang="ts">
import FForm from "@/components/form/FForm.vue";
import FDataTable from "@/components/table/FDataTable.vue";
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as ServerData from '@/../src-gen/server-data';
import * as Action from "@/../src-gen/action";

import { FSearchGridInput } from "@/components/generic/FSearchGridMDP";
import FSearchGrid from "@/components/generic/FSearchGrid.vue";
import ModelVue from "@/components/ModelVue";
import VerifiedClientListFSearchGridMDP from "./VerifiedClientListFSearchGridMDP";
import Helper from "@/util/Helper";

@Component({
  components: {
    FForm,
    FDataTable,
    FSearchGrid,
  },
})
export default class VerifiedClientList extends ModelVue {
//   @Store.Getter.Spine.SearchStore.partnerVerifiedClientSearchCriteria
//   searchCriteria: Data.Spine.SearchPartnerVerifiedClientInput;

//   @Store.Getter.Spine.SearchStore.partnerVerifiedClientList
//   partnerVerifiedClientList: Data.Spine.ClientFileSummary[];
searchCriteria: Data.Partner.OnboardedFileInput =
  new Data.Partner.OnboardedFileInput();

partnerVerifiedClientList: any[] = [];

get partnerId() {
  return localStorage.getItem("partnerId") || "";
}

  filterType = this.$route.params.filterType;
  partnerDetailsList: any = [];

  public mounted() {
    this.getFilter();
    this.getOnboardedFileList();
  }

  getFilter() {
    this.searchCriteria.partnerId = this.partnerId;

    const currentDateInfo = Helper.dateMTDWithCurrent();
    const { fromDate, toDate } = this.calculateDateRange(currentDateInfo);

    this.searchCriteria.fromDate = fromDate;
    this.searchCriteria.toDate = toDate;
  }

  calculateDateRange(currentDateInfo: any) {
    if (this.filterType === "currentDate") {
      return {
        fromDate: currentDateInfo.currentDate,
        toDate: currentDateInfo.currentDate,
      };
    } else if (this.filterType === "monthlyDate") {
      return {
        fromDate: currentDateInfo.startOfMonth,
        toDate: currentDateInfo.currentDate,
      };
    } else {
      return {
        fromDate: currentDateInfo.last7DaysToDate,
        toDate: currentDateInfo.currentDate,
      };
    }
  }
    getOnboardedFileList() {
    this.searchCriteria.partnerId = this.partnerId;
    Action.Partner.GetOnboardedFileList.execute(
        this.searchCriteria,
        (output) => {
        this.partnerVerifiedClientList = output;
        }
    );
    }

  get verifiedClientListFSearchGridMetaData() {
    return new VerifiedClientListFSearchGridMDP({
      parent: this,
      taskRoot: this,
    }).getMetaData();
  }

  get verifiedClientListSearchGridInput() {
    return new FSearchGridInput(
      this.searchCriteria,
      this.partnerVerifiedClientList
    );
  }

  set verifiedClientListSearchGridInput(newValue: FSearchGridInput) {
    this.searchCriteria = newValue.searchCriteria;
    this.partnerVerifiedClientList = newValue.searchResultList;
  }

//   clearFilter() {
//     return () => {
//       Store.Mutation.Spine.SearchStore.UPDATE_ACTIVE_PARTNER_SEARCH_CRITERIA(
//         new Data.Spine.SearchActivePartnerInput()
//       );
//       Store.Mutation.Spine.SearchStore.UPDATE_ACTIVE_PARTNER_LIST([]);
//     };
//   }
clearFilter() {
  return () => {
    this.searchCriteria = new Data.Partner.OnboardedFileInput();
    this.searchCriteria.partnerId = this.partnerId;
    this.partnerVerifiedClientList = [];
  };
}
}
</script>

<style></style>
